import { render, staticRenderFns } from "./tgAgreementDialog.vue?vue&type=template&id=c5a3fefc&scoped=true"
import script from "./tgAgreementDialog.vue?vue&type=script&lang=js"
export * from "./tgAgreementDialog.vue?vue&type=script&lang=js"
import style0 from "./tgAgreementDialog.vue?vue&type=style&index=0&id=c5a3fefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a3fefc",
  null
  
)

export default component.exports